import { pick } from 'ramda';
import { useCallback } from 'react';
import { useUserSelector } from 'js/store/hooks';

export const useGetGeoData = () => {
    const {
        geoData,
        countrySetByGeoIp: country
    } = useUserSelector(pick(['geoData', 'countrySetByGeoIp']));

    return useCallback(async () => {
        return {
            ...geoData,
            country
        };
    }, [
        geoData,
        country
    ]);
};
